export default {

    props: {
        disableIntersectionObserver: {    type: Boolean }
    },

    data: function () {
        const intersectionOptions = {
            rootMargin: '400px 200px',
            threshold: 0
        };
        return {
            observeVisibilityOptions: {
                callback: this.visibilityChanged,
                throttle: 300,
                throttleOptions: {leading: 'visible'},
                intersection: intersectionOptions
            },
            isIntersectionVisible: false,
            intersectionRemainsVisible: false,
            intersectionHideTimeout: 5000,
            intersectionOptions, // for customized components using the defaults
            debouncedHide: null
        };
    },

    created: function () {
        if (this.disableIntersectionObserver
            || this.isTestEnv) {

            this.isIntersectionVisible = true;
        }
    },

    mounted: function () {
        this.debouncedHide = _.debounce(this.onIntersectHide, this.intersectionHideTimeout, {trailing: true});
    },

    beforeDestroy: function () {
        this.debouncedHide.cancel();
        this.debouncedHide = null;
    },

    methods: {
        visibilityChanged: function (isVisible, entry) {
            if (this.disableIntersectionObserver) {
                return;
            }

            /**
             * was hidden, now shown
             */
            if (!this.isIntersectionVisible && isVisible && this.intersectionOptions) {
                this.debouncedHide.cancel();

                this.isIntersectionVisible = isVisible; // set before onIntersectShow
                this.onIntersectShow(entry);

                // if intersection should remain visible, v-observe-visibility options can be set to false
                if (this.intersectionRemainsVisible) {
                    this.intersectionOptions = false; // basically should halt the v-observe-visibility
                }
            }
            /**
             * was shown, now hidden
             */
            else if (this.isIntersectionVisible && !isVisible && !this.intersectionRemainsVisible) {
                this.isIntersectionVisible = isVisible;
                this.debouncedHide(entry);
            }
            else {
                this.isIntersectionVisible = isVisible;
            }
        },

        onIntersectShow: function (entry) {
            // console.log(`${this.$vnode && this.$vnode.tag} returning visible`);
        },

        onIntersectHide: function (entry) {
            // console.log(`${this.$vnode && this.$vnode.tag} turning invisible`);
        }
    }
};
